import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { StyleClass } from "../../../Shared/Styles/CSS";

export function DisplayViewChronologicalNote({
    rootNode,
}: {
    rootNode: IWorkflowNode;
}) {
    if (rootNode.viewchronological) {
        return (
            <div
                className={StyleClass(`DisplayViewChronologicalNote`, {
                    opacity: 0.5,
                })}
            >
                viewing chronologically
            </div>
        );
    }

    return null;
}
